import { ContentType } from '@confluence/content-types-utils/entry-points/contentTypeConstants';
import { useIsDataClassificationEnabledForOrg } from '@confluence/data-classification';
import { fg } from '@confluence/feature-gating';
import { useContentType } from '@confluence/page-context';
import { PageMode } from '@confluence/page-utils/entry-points/enums';
import { useGetPageMode } from '@confluence/page-utils/entry-points/useGetPageMode';

import { useContentClassification } from '../hooks/useContentClassification';

/**
 * Determines if the classification row should be displayed. This function is designed
 * to take no arguments, allowing it to be called from './InfoSection' to assess if
 * the section title should be shown. The title is not displayed if no sections are visible.
 */
export const useClassificationVisibility = () => {
	const [contentType] = useContentType();
	const pageMode = useGetPageMode();
	const { data } = useContentClassification();
	const { isEnabled: isDataClassificationEnabled } = useIsDataClassificationEnabledForOrg({
		skip: fg('disable_classification_enabled_query'),
	});
	//Read from different sources based on flag value
	const classificationFeatureEnabled = fg('disable_classification_enabled_query')
		? data?.featureEnabled
		: isDataClassificationEnabled;

	const isDataClassificationEmptyOnViewPage = pageMode === PageMode.VIEW && !data.classification;
	const isDataClassificationEnabledForContentType =
		contentType === ContentType.DATABASE || contentType === ContentType.WHITEBOARD;

	return (
		classificationFeatureEnabled &&
		(!isDataClassificationEmptyOnViewPage || isDataClassificationEnabledForContentType)
	);
};
